import axios from "axios";

export const getOrders = async (authtoken) =>
  await axios.get(`${process.env.REACT_APP_API}/admin/orders`, {
    headers: {
      authtoken,
    },
  });

export const getOrder = async (_id, authtoken) =>
  await axios.get(`${process.env.REACT_APP_API}/admin/order/${_id}`, {
  });

export const getDownloadOrder = async (_id, authtoken) =>
  await axios.get(`${process.env.REACT_APP_API}/admin/order/${_id}?type=download`, {
  });

export const findPincodeStore = async (code) =>
  await axios.get(`${process.env.REACT_APP_API}/find-pincode-store?pincode=${code}`);


export const removeOrder = async (_id, authtoken) =>
  await axios.delete(`${process.env.REACT_APP_API}/order/${_id}`, {
    headers: {
      authtoken,
    },
  });

export const getTodaysOrders = async (_id, authtoken) =>
  await axios.get(`${process.env.REACT_APP_API}/order/todays-sale`, {
  });


export const getOrdersCount = async () =>
  await axios.get(`${process.env.REACT_APP_API}/orders/total`);

export const changeStatus = async (orderId, orderStatus, authtoken) =>
  await axios.put(
    `${process.env.REACT_APP_API}/admin/order-status`,
    { orderId, orderStatus },
    {
      headers: {
        authtoken,
      },
    }
  );

export const getOrders1 = async (sort, order, page) =>
  await axios.post(`${process.env.REACT_APP_API}/orders`, {
    sort,
    order,
    page,
  });

export const updateOrder = async (_id, values, authtoken) =>
  await axios.put(`${process.env.REACT_APP_API}/order/${_id}`, values, {
    headers: {
      authtoken,
    },
  });

export const getOrdersSale = async () =>
  await axios.get(`${process.env.REACT_APP_API}/order/totalsale`);

export const createLog = async (log, email, authtoken) =>
  await axios.post(`${process.env.REACT_APP_API}/admin/user/log`, {
    log,
    email
  });

export const getLogs = async (email, authtoken) =>
  await axios.post(`${process.env.REACT_APP_API}/admin/user/get-logs`, {
    email
  });

export const getStoreOrders = async (authtoken) =>
  await axios.post(`${process.env.REACT_APP_API}/store/store-orders`, {}, {
    headers: {
      authtoken,
    },
  });

export const getDistance = async (latitude, longitude, lat, lon) =>
  await axios.get(`https://api.tomtom.com/routing/1/calculateRoute/${latitude}%2C${longitude}%3A${lat}%2C${lon}/json?avoid=unpavedRoads&key=XyJaWWJUxOhEEHqXbs22935YW8izs7Cs`);

export const getDistanceEOK = async (lat, lon) =>
  await axios.get(`https://api.tomtom.com/routing/1/calculateRoute/28.554146%2C77.2433115%3A${lat}%2C${lon}/json?avoid=unpavedRoads&key=XyJaWWJUxOhEEHqXbs22935YW8izs7Cs`);

export const getFinalDistance = async (latitude, longitude, lat, lon) => {
  await axios.get(`https://api.tomtom.com/routing/1/calculateRoute/28.6407255%2C77.1183406%3A${lat}%2C${lon}/json?avoid=unpavedRoads&key=XyJaWWJUxOhEEHqXbs22935YW8izs7Cs`);

}

export const getPincodeDetails = async (id) =>
  await axios.get(`https://api.tomtom.com/search/2/geocode/${id}.json?lat=37.337&lon=-121.89&key=XyJaWWJUxOhEEHqXbs22935YW8izs7Cs`);


export const getZipCodeDetails = async (lat, lon) =>
  await axios.get(`https://api.tomtom.com/search/2/reverseGeocode/${lat}%2C${lon}json?key=XyJaWWJUxOhEEHqXbs22935YW8izs7Cs`);


export const sendFranchiseForm = async (values) =>
  await axios.post(`${process.env.REACT_APP_API}/user/franchise-form`, values);

export const sendExhibitionForm = async (values) =>
  await axios.post(`${process.env.REACT_APP_API}/exhibition`, values);

export const getExhibitionList = async (sort, order, page) =>
  await axios.get(`${process.env.REACT_APP_API}/list-exhibition?sort=${sort}&&order=${order}&&page=${page}`);

export const getSalesHistory = async (start, end, authtoken) =>
  await axios.get(`${process.env.REACT_APP_API}/admin/orders-history?start=${start}&&end=${end}`, {
    headers: {
      authtoken,
    },
  });


export const downloadExhibitionNum = async (authtoken) =>
  await axios.get(`${process.env.REACT_APP_API}/download-exhibition`, {
    headers: {
      authtoken,
    },
  });

export const createAmazonItem = async (values, authtoken) =>
  await axios.post(`${process.env.REACT_APP_API}/create-amazon`, values, {
    headers: {
      authtoken,
    },
  });

export const updateAmazonPictures = async (page, limit, authtoken) =>
  await axios.post(`${process.env.REACT_APP_API}/update-amazon?page=${page}&limit=${limit}`, {}, {
    headers: {
      authtoken,
    },
  });

  export const updateMetaProducts = async (method, authtoken, productId = null) => {
    const url = productId
      ? `${process.env.REACT_APP_API}/update-facebook?method=${method}&productId=${productId}`
      : `${process.env.REACT_APP_API}/update-facebook?method=${method}`;
  
    return await axios.post(url, {}, {
      headers: {
        authtoken,
      },
    });
  };
  